import axios from 'axios';
import querystring from 'querystring';

async function getKeysDetails(keys) {
  const url = 'Boarding/KeysDetails';
  const request = {
    method: 'GET',
    url: url,
    params: { keys },
    paramsSerializer: (params) => querystring.stringify(params),
  };

  const res = await axios(request);
  return res.data;
}

async function getDealers() {
  const url = 'BoardingOrder/DealerList';
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getKeyDetails(dealerId, keyId) {
  const url = 'BoardingOrder/LookupLicenseKey';
  const request = {
    method: 'GET',
    url: url,
    params: { dealer_id: dealerId, key_id: keyId },
  };

  try {
    const res = await axios(request);
    return res.data;
  }
  catch (error) {
    return Promise.reject(error?.response?.data);
  }
}

async function getUserDetails(dealerId, email) {
  const url = 'BoardingOrder/LookupUser';
  const request = {
    method: 'GET',
    url: url,
    params: { dealer_id: dealerId, email },
  };

  try {
    const res = await axios(request);
    return res.data;
  }
  catch (error) {
    return Promise.reject(error?.response?.data);
  }
}

async function insertOrder(order) {
  const url = `BoardingOrder`;
  const request = {
    method: 'POST',
    url: url,
    data: order,
  };

  const res = await axios(request);
  return res.data;
}

async function getOrderConfirmation(orderId) {
  const url = `BoardingOrder/Confirmation/${orderId}`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getOrderDetails(orderId) {
  const url = `BoardingOrder/Details/${orderId}`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getOrderWorkflow(orderId) {
  const url = `BoardingOrder/Workflow/${orderId}`;
  const request = {
    method: 'GET',
    url: url,
  };

  const res = await axios(request);
  return res.data;
}

async function getOrderDashboard({ pageSize, pageOffset, dealerId }) {
  const url = `BoardingOrder/Dashboard`;
  const request = {
    method: 'POST',
    url: url,
    data: {
      pageSize,
      pageOffset,
      dealerId,
    },
  };
  const res = await axios(request);
  return res.data;
}




const BoardingService = {
  API: {
    getKeysDetails,
    getDealers,
    getKeyDetails,
    getUserDetails,
    insertOrder,
    getOrderConfirmation,
    getOrderDetails,
    getOrderWorkflow,
    getOrderDashboard,
  },
};

export default BoardingService;